import { TOfferDataParam } from '../types';

export function isNewbuildingOnly(data: TOfferDataParam): boolean {
  return data.jsonQuery?.building_status?.value === 2;
}
